<div class="timeline">
  <div *ngFor="let transship of transshipments; let i = index" class="content" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="center center">
    <mat-icon class="icon" *ngIf="i == 0; else checkpoint">
      <fa-icon [icon]="shipmentMethod == transhipmentType.plane ? faPlaneDeparture : faShip"></fa-icon>
    </mat-icon>
    <ng-template #checkpoint>
      <mat-icon class="icon">
        <fa-icon
          [icon]="
            transshipments.length == i + 1 && shipmentMethod == transhipmentType.plane
              ? faPlaneArrival
              : transshipments.length == i + 1 && shipmentMethod == transhipmentType.ship
              ? faAnchor
              : faMapMarkerAlt
          "
        ></fa-icon>
      </mat-icon>
    </ng-template>

    <app-port-airport-autocomplete-native
      [class.invalid-field]="showErrors && (!transship?.id || transship?.id === -1)"
      fxFlex="70"
      [label]="getLabel(i)"
      [readonlyField]="readonlyField"
      [hiddenFields]="getIds()"
      [reset]="reset"
      [isSummary]="isSummary"
      [isNewTrade]="isNewTrade"
      [transshipmentMethod]="shipmentMethod"
      [CertificateProcessing]="CertificateProcessing"
      [defaultTransshipment]="transship"
      (selectedTransshipment$)="setTransshipment($event, i)"
      (resetEvent)="emitReset()"
      (validateTransshipment$)="validateTransshipment($event)"
    ></app-port-airport-autocomplete-native>
  </div>
</div>
